<template>
	<el-card>
		<el-table ref="multipleTable" :data="postList" tooltip-effect="dark">
			<el-table-column prop="id" label="ID" width="50">
			</el-table-column>
			<el-table-column prop="uid" label="发布人" width="200">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;">
						<el-avatar style="margin-right: 10px;" :src="scope.row.userInfo.avatar"></el-avatar>
						<span>{{scope.row.userInfo.nickname}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="内容" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="read_count" label="阅读量">
			</el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="添加时间">
			</el-table-column>
			<el-table-column>
				<template slot-scope="scope">
					<el-button @click="fabulousPost(scope.row.id,scope.$index)" type="primary" plain>点赞</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
			layout="total,prev,pager,next" :total="postLength">
		</el-pagination>
		<!-- 选择马甲弹窗 -->
		<el-dialog title="选择马甲" :visible.sync="userDialogVisible" width="70%">
			<el-table ref="multipleTable" :data="userList" tooltip-effect="dark" @selection-change="selsChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="sex" label="性别"> </el-table-column>
				<el-table-column prop="phone" label="手机号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="create_time" label="注册时间" show-overflow-tooltip>
				</el-table-column>
			</el-table>
			<el-pagination @current-change="handleUserCurrentChange" :current-page="usercurrentPage" :page-size="pagesize"
				layout="total,prev,pager,next,jumper" :total="userLength">
			</el-pagination>
			<div slot="footer">
				<el-button @click="userDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="fabulousPost">确 定</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				sels: [], //选中的值显示
				currentPage: 1,
				usercurrentPage: 1,
				postList: [],
				postLength: 0,
				userDialogVisible: false,
				userList: [],
				userLength: 0,
				pagesize: 0,
				checkUids: [],
				postId:""
			}
		},
		created() {
			this.handleCommunityList();
			this.getUserList();
		},
		methods: {
			selsChange(e) {

				let uids = [];
				e.forEach(item => {
					uids.push(item.uid)
				})

				this.checkUids = uids
			},
			handleCommunityList() {
				this.$H.get("post/list", {
					page: this.currentPage,
				}).then((res) => {
					this.postList = res.result.data;
					this.pagesize = res.result.per_page;
					this.postLength = res.result.total;
				})
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.handleCommunityList();
			},
			handleUserCurrentChange(usercurrentPage) {
				this.usercurrentPage = usercurrentPage;
				this.getUserList();
			},
			fabulousPost(id, index) {
				if (this.userDialogVisible) {
					let loading = this.$loading({
						text: '请求中',
					})
					
					this.$H.post("post/vestFabulous",{
						id:this.postId,
						uids:this.checkUids
					}).then( res =>{
						loading.close();
						this.userDialogVisible = false;
					})
				} else {
					this.postId = id;
					this.userDialogVisible = true;
				}
			},
			getUserList() {
				this.$H
					.get("user/list", {
						page: this.usercurrentPage,
						type: 2
					})
					.then((res) => {
						this.userList = res.result.data;
						this.userLength = res.result.total;
						this.pagesize = res.result.per_page;
					});
			}
		}
	}
</script>

<style>
</style>
